import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react"

export const PreferencesPopup = forwardRef(({ data }: { data: any }, ref) => {
    const [isShow, setIsShow] = useState(false);

    const [preferencesValues, setPreferencesValues] = useState({
        mark_sms: 1,
        mark_email: 1,
        mark_call: 1,
        mark_app: 1,
        mark_send: 0,
    });

    const handleCheck = ({ target }: { target: HTMLInputElement }) => {
        const { id, checked } = target;
        setPreferencesValues({ ...preferencesValues, [id]: checked ? 1 : 0 });
    }

    const hidePreferences = () => {
        history.replaceState(null, '', window.location.pathname + window.location.search);
        setIsShow(false);
    }

    useEffect(() => {
        const handleHashChange = () => window.location.hash && setIsShow(true);
        handleHashChange();

        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    useImperativeHandle(ref, () => {
        return {
            preferencesValues,
        };
    })

    return (
        <section id="preferences_popup" className={`ar__preferences ${isShow ? 'ar__preferences--active' : ''}`}>
            <div className="ar__preferences__container">
                <span className="ar__preferences__close" contentEditable="false" onClick={hidePreferences}></span>
                <article className="ar__preferences__body">
                    {data?.title && <header className="ar__preferences__title" dangerouslySetInnerHTML={{ __html: data.title.value || '' }}></header>}
                    <form id="preferences-form" className="ar__form_v2">
                        {
                            data?.sms
                            && (
                                <fieldset className="js-form-item js-form-type-checkbox">
                                    <input type="checkbox" name="mark_sms" id="mark_sms" checked={!!preferencesValues.mark_sms} onChange={handleCheck} />
                                    <label htmlFor="mark_sms">{data.sms}</label>
                                </fieldset>
                            )
                        }
                        {
                            data?.email
                            && (
                                <fieldset className="js-form-item js-form-type-checkbox">
                                    <input type="checkbox" name="mark_email" id="mark_email" checked={!!preferencesValues.mark_email} onChange={handleCheck} />
                                    <label htmlFor="mark_email">{data?.email}</label>
                                </fieldset>
                            )
                        }
                        {
                            data?.call
                            && (
                                <fieldset className="js-form-item js-form-type-checkbox">
                                    <input type="checkbox" name="mark_call" id="mark_call" checked={!!preferencesValues.mark_call} onChange={handleCheck} />
                                    <label htmlFor="mark_call">{data?.call}</label>
                                </fieldset>
                            )
                        }
                        {
                            data?.app
                            && (
                                <fieldset className="js-form-item js-form-type-checkbox">
                                    <input type="checkbox" name="mark_app" id="mark_app" checked={!!preferencesValues.mark_app} onChange={handleCheck} />
                                    <label htmlFor="mark_app">{data?.app}</label>
                                </fieldset>
                            )
                        }
                        {
                            data?.['off-work']
                            && (
                                <fieldset className="js-form-item js-form-type-checkbox">
                                    <input type="checkbox" name="mark_send" id="mark_send" checked={!!preferencesValues.mark_send} onChange={handleCheck} />
                                    <label htmlFor="mark_send">{data?.['off-work']}</label>
                                </fieldset>
                            )
                        }
                        {
                            data?.btn
                            && (
                                <button onClick={hidePreferences} className="ar__login_v2__submit" type="button">{data?.btn}</button>
                            )
                        }
                    </form>
                </article>
            </div>
        </section>
    )
})